import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { trackAddToCart, trackInitiateCheckout } from '../utils/pixel';
export const StickyOfferBar = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleClick = () => {
    trackAddToCart();
    trackInitiateCheckout();
    window.location.href = 'https://valordigital.store/cart/46518849142973:1';
  };
  return <AnimatePresence data-id="element-475">
      {isVisible && <motion.div initial={{
      y: '-100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '-100%'
    }} transition={{
      duration: 0.3,
      ease: 'easeInOut'
    }} className="fixed top-0 left-0 right-0 z-40 bg-black py-2 px-4 shadow-md" data-id="element-476">
          <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center md:justify-between gap-2 md:gap-4" data-id="element-477">
            <span className="text-white font-montserrat font-bold text-sm md:text-base text-center" data-id="element-478">
              🔥 70% OFF — $14.990
            </span>
            <button onClick={handleClick} className="bg-[#22c55e] hover:bg-[#16a34a] text-white font-montserrat font-bold text-sm py-1.5 px-4 rounded-lg transition-colors" data-id="element-479">
              Comprar Ahora
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
};